import React from "react";
import { Link } from "react-router-dom";
import DataSender from "../../lib/DataSender";

class End extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.location.state;
    this.ds = new DataSender();
  }

  componentDidMount() {
    let sendBody = {
      ...this.state,
      soldierId: this.state.id,
    };

    sendBody.tempeture = parseFloat(sendBody.tempeture);
    sendBody.alcohol = parseFloat(sendBody.alcohol);
    sendBody.pulse = parseInt(sendBody.pulse);

    this.ds.health(sendBody);
  }

  render() {
    return (
      <div>
        <h1 style={{ marginTop: "100px" }}>결과 확인</h1>
        <span className="warning">
          모두 입력 되었습니다. 다시 한번 확인해주세요.
        </span>
        <div className="result-user-data-qr">{/* <img></img> */}</div>
        <div className="result-user-data">
          <p>이름 : {this.state.name}</p>
          <p>전화번호 : {this.state.phone_number}</p>
          <p>
            부대 : {this.state.army_unit ? this.state.army_unit.unitName : ""}
          </p>
          <p>생년월일 : {this.state.birth}</p>
        </div>
        <div className="healthcheck healthcheck-end">
          <div className="healthcheck-container">
            <div className="healthcheck-tb">
              <div className="healthcheck-td" id="s-cover">
                <div className="healthcheck-button">
                  <img
                    src="https://img.icons8.com/emoji/48/000000/thermometer-emoji.png"
                    alt="체온"
                  />
                </div>
              </div>
              <div className="healthcheck-td">
                <input
                  type="text"
                  placeholder="체온"
                  required
                  readOnly
                  value={this.state.tempeture}
                />
              </div>
              <div className="healthcheck-td">
                <p>℃</p>
              </div>
            </div>
          </div>
          <div className="healthcheck-container">
            <div className="healthcheck-tb">
              <div className="healthcheck-td" id="s-cover">
                <div className="healthcheck-button">
                  <img
                    src="https://img.icons8.com/cotton/64/000000/whiskey.png"
                    alt="음주"
                  />
                </div>
              </div>
              <div className="healthcheck-td">
                <input
                  type="text"
                  placeholder="음주"
                  required
                  readOnly
                  value={this.state.alcohol}
                />
              </div>
              <div className="healthcheck-td">
                <p>%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="healthcheck healthcheck-end">
          <div className="healthcheck-container">
            <div className="healthcheck-tb">
              <div className="healthcheck-td" id="s-cover">
                <div className="healthcheck-button">
                  <img
                    src="https://img.icons8.com/fluent/48/000000/heart-with-pulse.png"
                    alt="맥박"
                  />
                </div>
              </div>
              <div className="healthcheck-td">
                <input
                  type="text"
                  placeholder="맥박"
                  required
                  readOnly
                  value={this.state.pulse}
                />
              </div>
              <div className="healthcheck-td">
                <p>회</p>
              </div>
            </div>
          </div>
          <div className="healthcheck-container">
            <div className="healthcheck-tb">
              <div className="healthcheck-td" id="s-cover">
                <div className="healthcheck-button">
                  <img
                    src="https://img.icons8.com/plasticine/100/000000/military-uniform.png"
                    alt="복장"
                  />
                </div>
              </div>
              <div className="healthcheck-td">
                <div className="toggle checkcross">
                  <input
                    id="checkcross"
                    type="checkbox"
                    disabled="disabled"
                    checked={this.state.garments}
                  />
                  <label className="toggle-item" htmlFor="checkcross">
                    <div className="check"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="end-buttons">
          <Link to="/Main" className="end-button">
            <button className="button">
              <p>메인으로</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default End;
